import React from 'react';

class SharedElementSelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = { isLoading: false, isOnlyThisFlowEnabled: true };

        this.onOnlyThisFlowChanged = this.onOnlyThisFlowChanged.bind(this);
    }

    onOnlyThisFlowChanged(e) {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);

        model.objectDataRequest.configurationValues = [
            {
                contentType: manywho.component.contentTypes.string,
                developerName: 'FlowId',
                contentValue: (e.target.checked) ? this.flowId : null
            }
        ];

        manywho.engine.objectDataRequest(this.props.id, model.objectDataRequest, this.props.flowKey, 1000);

        this.setState({ isOnlyThisFlowEnabled: e.target.checked });
    }

    componentDidMount() {
        if (!this.props.isDesignTime) {
            const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
            this.flowId = manywho.utils.getObjectDataProperty(model.tags, 'FlowId').contentValue;
        }
    }

    render() {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        const state = manywho.state.getComponent(this.props.id, this.props.flowKey) || {};

        const className = ['mw-shared-element-select'];
        if (!model.isVisible)
            className.push('hidden');

        return (<div className={className.join(' ')}>
                    {React.createElement(manywho.component.getByName('select'), { flowKey: this.props.flowKey, id: this.props.id, parentId: this.props.parentId, isDesignTime: this.props.isDesignTime })}
                    <div className="form-group">
                        <label>
                            <input type="checkbox" checked={this.state.isOnlyThisFlowEnabled} onChange={this.onOnlyThisFlowChanged} disabled={state.loading != null}/>
                            <span>Only show {model.attributes.elementLabel} already being used in this Flow</span>
                        </label>
                    </div>
                </div>)
    }

}

export default SharedElementSelector;

manywho.component.registerAlias('mw-shared_element_selector', 'mw-select');
